import React, { useState } from 'react'
import { Checkbox, List, useTheme } from 'react-native-paper'
import { SearchBarWithIcon, TextBodySecondary } from '../../../../../../../ui/atoms'
import { ButtonFlowNext } from '../../../../../../../ui/molecules/ButtonFlowNext'
import { toJS } from 'mobx'

export default {
  title: 'What the trade(s) do you perform for this project?',
  description:
    'Please choose all the option that apply to you from the list below',
  view: (currentData) => {
    if (!currentData || !currentData.content) return ''
    return currentData.content.join(', ')
  },
  component: ({ onValue, currentData, ...props }) => {
    const data = toJS(currentData?.content || [])
    const [checked, setChecked] = useState(data)

    const checkbox = [
      'Appliance Installation',
      'Ceramic and Mosaic Tile',
      'Countertop Instalation',
      'Concrete and Foundation',
      'Drywall and Plaster',
      'Electrical, Low Voltage',
      'Elevator',
      'Finish Carpentry, Cabinet and Millwork',
      'Flooring and Floor Covering',
      'Framing and Rough Carpentry Contractor',
      'Glazing, Glass and Mirror',
      'Heating, Ventilating and Air-Conditioning',
      'Insulation and Acoustical',
      'Lathing and Plastering',
      'Landscaping, Paving, Earthwork',
      'Masonry',
      'Painting and Decorating',
      'Plumbing, Pipeline, and Fire Protection',
      'Roofing',
      'Structural Steel, Reinforcing Steel, and Sheet Metal',
      'Solar',
      'Swimming Pool',
    ]

    const { colors: { primary }, } = useTheme()

    const [searchQuery, setSearchQuery] = React.useState('')

    return (
      <>
        <SearchBarWithIcon value={searchQuery} onChangeText={setSearchQuery}
                           style={{ marginTop: 15, marginHorizontal:15, flex: 1, paddingLeft: 20, paddingRight: 40 }}/>
        {checkbox.filter(check => check.toLowerCase().includes(searchQuery.toLowerCase())).map((trade) => {
          const isChecked = checked.includes(trade)
          const onPress = () => {
            if (isChecked) {
              setChecked([...checked.filter((_trade) => _trade !== trade)])
            } else {
              setChecked([...checked, trade])
            }
          }
          return (

            <List.Item
              key={trade}
              title={trade}
              onPress={onPress}
              style={{
                borderBottomWidth: 1,
                width: '100%',
                borderColor: 'grey',
              }}
              right={() => (
                <Checkbox
                  color={primary}
                  uncheckedColor={'black'}
                  status={isChecked ? 'checked' : 'unchecked'}
                  onPress={onPress}
                />
              )}
            >
              <TextBodySecondary style={{ marginTop: 0 }}>
                {trade}
              </TextBodySecondary>
            </List.Item>
          )
        })}
        <ButtonFlowNext disabled={checked.length === 0} onPress={() => onValue(checked)} {...props} />
      </>
    )
  },
  next: 'projectInfo.projectPayingParty',
}
